import { Alert, AlertTitle, Box, Stack, Typography } from '@mui/material';
import { Karta } from '@/components/Karta';
import { NaglowekEkranu } from '@/components/NaglowekEkranu';
import { useZdolnosci } from '@/lib/useAnalytics';

/**
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 * MENU RESTAURACJI — EKRAN, KTÓRY MÓWI PRAWDĘ O TYM, CZEGO JESZCZE NIE MA
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 *
 * ┌─ „FUNKCJA OCZEKUJE NA INTEGRACJĘ", A NIE „BRAK DANYCH" ─────────────────────────────────────┐
 * │ Te dwa komunikaty prowadzą do dwóch różnych działań. „Brak danych" mówi restauracji:        │
 * │ sprawdź, czemu nic nie wprowadziłaś. „Oczekuje na integracji" mówi: to my jeszcze tego nie  │
 * │ podłączyliśmy, nie szukaj błędu u siebie.                                                    │
 * │                                                                                              │
 * │ Pusta tabela w miejscu niedokończonej funkcji jest kosztowna dokładnie w ten sposób:         │
 * │ wysyła człowieka szukać usterki, której nie ma.                                              │
 * └──────────────────────────────────────────────────────────────────────────────────────────────┘
 *
 * Czego brakuje i u kogo — mówimy wprost, bo to jedyna wersja, którą da się sprawdzić:
 *   • API zapisu dań i menu w systemie głównym  → strumień R5-03,
 *   • replikacja katalogu dań i historii cen     → strumień R5-04.
 *
 * Zdolności czytamy Z SERWERA, a nie ze zmiennej budowania: ta sama paczka stoi obok środowiska,
 * w którym API zapisu jest, i obok takiego, w którym go nie ma.
 */
export function MenuRestauracjiPage() {
  const zdolnosci = useZdolnosci();
  const zapisMenu = zdolnosci.data?.zdolnosci?.menu_zapis;
  const zapisDan = zdolnosci.data?.zdolnosci?.dania_zapis;

  return (
    <Stack spacing={2}>
      <NaglowekEkranu
        tytul="Menu"
        opis="Menu w szkołach już przypisanych do Twojej restauracji."
      />

      <Alert severity="info">
        <AlertTitle>Funkcja oczekuje na integrację</AlertTitle>
        <Typography variant="body2" sx={{ mb: 1 }}>
          Układanie menu wymaga zapisu do systemu głównego TuSzamy. Ta droga nie jest jeszcze
          podłączona do panelu, więc ekran nie pokazuje pustej tabeli, która sugerowałaby, że
          menu po prostu nie ma.
        </Typography>
        <Typography variant="body2">
          Karta dań jest już dostępna — w zakładce <strong>Dania / Posiłki</strong> widać
          aktualny stan pozycji tej restauracji.
        </Typography>
      </Alert>

      <Karta>
        <Stack spacing={1} sx={{ p: 2 }}>
          <Typography sx={{ fontWeight: 800, fontSize: 14 }}>Stan podłączenia (odczytany z serwera)</Typography>
          <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
            <Typography component="li" variant="body2">
              Zapis menu: <strong>{zapisMenu ? 'dostępny' : 'niedostępny'}</strong>
            </Typography>
            <Typography component="li" variant="body2">
              Zapis dań: <strong>{zapisDan ? 'dostępny' : 'niedostępny'}</strong>
            </Typography>
          </Box>
          <Typography variant="caption" sx={{ color: 'var(--tekst-slaby)' }}>
            Gdy zapis zostanie podłączony, ta zakładka zacznie działać bez zmiany w panelu —
            ekran pyta o zdolności serwer, a nie własną konfigurację budowania.
          </Typography>
        </Stack>
      </Karta>

      <Alert severity="warning">
        <AlertTitle>Czego panel nigdy nie zrobi</AlertTitle>
        <Typography variant="body2">
          Menu można będzie układać wyłącznie w szkołach już przypisanych do Twojej restauracji.
          Przypisania szkół nadaje administracja — restauracja nie nadaje ich sobie sama.
          Każda zmiana pozycji przechodzi przez moderację; nie ma drogi, która by ją omijała.
        </Typography>
      </Alert>
    </Stack>
  );
}

export default MenuRestauracjiPage;
